
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'BlogPost',
  head() {
    return {
      title: this.postTitle,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.postTitle,
        },
        {
          hid: 'og:type',
          name: 'og:type',
          content: 'article',
        },
        {
          hid: 'og:site_name',
          name: 'og:site_name',
          content: 'Motion Routes',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.postMetaDescription,
        },
        {
          hid: 'description',
          name: 'description',
          content: this.postMetaDescription,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: this.postFeaturedImage,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          keywords: this.postTags,
        },
      ],
    };
  },
  async mounted() {
    await this.loadSinglePost(this.$route.params.id);
  },
  methods: {
    ...mapActions('posts', ['loadSinglePost']),
  },

  computed: {
    ...mapGetters('posts', ['getSelectedPost']),
    ...mapState('posts', ['isLoaded']),
    postTags() {
      return this.getSelectedPost?.tags?.map((i) => i.substring(1)).toString();
    },
    postFeaturedImage() {
      return this.getSelectedPost.thumbnailURL;
    },
    postTitle() {
      return this.getSelectedPost.title;
    },
    postMetaDescription() {
      return this.getSelectedPost.textPreview;
    },
  },
};
